var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdlefinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    alt: "Logo for Idle Finance",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Idle Finance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    rx: 32,
    fill: "#BED9FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3300_8585)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.812 22.5V68.2907H27V33.5938L48.812 22.5Z",
    fill: "#0414D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.188 79.5V33.4204H75V33.9404V68.3773L53.188 79.5Z",
    fill: "#0414D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3300_8585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 57,
    fill: "white",
    transform: "translate(27 22.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdlefinance);
export default __webpack_public_path__ + "static/media/idlefinance.98f0462726494b8c261e1cca1a36e465.svg";
export { ForwardRef as ReactComponent };